/**
 * The functional component assists in listing Documents 
 * 
 */
//  Generic imports
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Truncate } from '@re-dev/react-truncate';
import PropTypes from "prop-types";

//  Motif imports
import { MotifBadge, MotifToast, MotifButton, MotifTooltip } from "@ey-xd/motif-react";
import MotifModal, { MotifModalHeader, MotifModalBody, MotifModalFooter } from '@ey-xd/motif-react/Modal';

//  Inetrnal imports
import "./DocumentList.scss";
import DocumentService from '../../../../services/documentService';

//  Icons imports
import iconPage from "../../../../assets/images/page.svg";
import iconProgressLoaderCircle from "../../../../assets/images/Loading_indicator_circles.svg";
import iconEmptyDoc from "../../../../assets/images/emptydoc.svg";
import iconRefresh from "../../../../assets/images/refresh.svg";
import iconVector from "../../../../assets/images/multiple-pages.svg";
import iconCheckCircle from "../../../../assets/images/check-circle.svg";

const DocumentList = ({ isOpen, setOnclose  })   =>{
    let InititaData = [];
    const [documents, setDocuments] = useState([]);
    const [showMessage, setShowMessage] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const { activeProject } = useSelector(state => state.user);
    const projectId = activeProject.project_UUID;
    const dataHostingLocation = activeProject?.dataHostingLocation;
    const documentService = new DocumentService();
    const filterDocuments = documents.filter(doc => doc.status === 'Complete' || doc.status === 'Deleted' || doc.status === 'Delete InProgress')
    const totalDocuments = filterDocuments.length;

    // Sorting documents so that active documents come first
    const sortedDocuments = [...filterDocuments].sort((a, b) => {
        if (a.status === 'Complete' && b.status !== 'Complete') return -1;
        if (a.status !== 'Complete' && b.status === 'Complete') return 1;
        return 0;
    });

   useEffect(() => {
          getUploadedDocuments();
          // eslint-disable-next-line
      }, []);
  
  
      /**
    * This function helps to fetch Documents
    * @param {*} refreshFlag  : Boolean
    */
      const getUploadedDocuments = async (refreshFlag) => {
          setShowLoader(true);
          InititaData = await documentService.getDocuments(projectId);
          if(InititaData){
              setDocuments(InititaData);
          }
          setShowLoader(false);
          if (refreshFlag) {
              setShowMessage(true);
          }
      };
  
      const refreshList = () => {
          getUploadedDocuments(true);
      };
  
      const platformRedirectClick = () => {
          const base = process.env.REACT_APP_DOCUMENTS_PLATFORM_URL;
          const url = base + "?p_id=" + projectId + "&dataHostingLocation=" + dataHostingLocation;
          window.open(url, '_blank');
      };
  
      const oncloseclick = () => {
          setShowMessage(false);
      };
  
  return (
    <MotifModal
        show={isOpen}
        onClose={()=>setOnclose(!isOpen)}
        className="documentsModal modalMotifFooterModal"
        size='md'
    >
        <MotifModalHeader
        closeButtonProps={{
            'aria-label': 'Custom Close Button aria-label',
            title: 'Custom Close Button title'
        }}
        className="documentsHeader"
        >
            <div className="docBadge">
        <div className="docHeader">Documents</div>
        <MotifBadge
            value={totalDocuments} variant="default"
            className="document-badge" />
            </div>
        </MotifModalHeader>
        <MotifModalBody className="documentModalBody">
                    {showLoader ? (
                        <div className="loaderDiv">
                            <div>
                                <img src={iconProgressLoaderCircle} alt='Progress'
                                    className="refreshIcon " />
                            </div>
                            <div className="refreshListText">
                                Refreshing List...
                            </div>
                        </div>
                    ) : (
                        <>
                            {filterDocuments.length === 0 ? (
                                <div className="no-doc-info-container">
                                    <img className="no-doc-info-image"
                                        src={iconEmptyDoc} alt=""></img>
                                    <div>
                                        <div className="no-doc-text-info">
                                            No documents found</div>
                                        <p className="no-doc-description">
                                            To add documents to your project,<br />
                                            click on <span className="no-doc-bold-description">Access Document Library
                                            </span></p>
                                    </div>
                                </div>
                            ) : (
                                <div className="documentList">
                                    {sortedDocuments.map((doc, i) => (
                                        <div className="doc-list" key={doc.documentId}>
                                            <div className={`documentList-item ${doc.status === "Deleted" ? "deleted" : "active"}`}>
                                                <img src={iconPage} alt="Document" className="doc-image"/>
                                                <div className="documentList-name">
                                                    <Truncate
                                                        ellipsis={
                                                            <MotifTooltip
                                                                trigger={
                                                                    <span>…</span>
                                                                }
                                                                allowClick={false}
                                                                hideCloseButton={true}
                                                                contentClassName="tooltipFont tooltipWrap"
                                                            >
                                                                {doc.documentName}
                                                            </MotifTooltip>
                                                        }
                                                    >{doc.documentName}</Truncate>
                                                </div>
                                                <div className="documentList-status" >
                                                    {doc.status === "Complete" ? "Active" : "Deleted"}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                </MotifModalBody>
                    <MotifModalFooter className="document-footer">
                        {showMessage && (
                            <MotifToast
                                className="notifyToast"
                                variant="success"
                                icons={{ toast: <img src={iconCheckCircle} alt="Success" /> }}
                                actionName=""
                                position=""
                                onClose={() => {
                                    oncloseclick();
                                }}
                            >
                                <div>Refresh Complete</div>
                            </MotifToast>
                        )}      
                        <div className="footerButtons">
                            <MotifButton className="btnRefreshDocument" variant="secondary"
                                onClick={() => refreshList()}>
                                <img src={iconRefresh} alt="Refresh" className="iconRefresh" />Refresh
                            </MotifButton>
                            <MotifButton className="btnAccessDocument"
                                variant="primary" onClick={() => platformRedirectClick()}>
                                <img src={iconVector} alt="Document" className="iconAccessDocument" />
                                <span className="textEllipsis">Access Document Library</span>
                            </MotifButton>
                        </div>
                </MotifModalFooter>
    </MotifModal>
  );
}

DocumentList.propTypes = {
    isOpen: PropTypes.bool,
    setOnclose: PropTypes.func
};

export default DocumentList;
